import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import HomePage from "../pages/home/page";
import GuidePage from "../pages/guide/page";
import BlogPage from "../pages/blog/page";
import BlogDetailPage from "../pages/blog-detail/page";
import AdminLoginPage from "../pages/admin-login/page";
import AdminDashboardPage from "../pages/admin-dashboard/page";
import TokushohoPage from "../pages/tokushoho/page";
import PrivacyPage from "../pages/privacy/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/guide",
    element: <GuidePage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:id",
    element: <BlogDetailPage />,
  },
  {
    path: "/tokushoho",
    element: <TokushohoPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/admin/login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin/dashboard",
    element: <AdminDashboardPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
